import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/sections/Header";
import Hero from "./components/sections/Hero";
import History from "./components/sections/History";
import Family from "./components/sections/Family";
import Banner28 from "./components/sections/Banner28";
import Gallery from "./components/sections/Gallery";
import Social from "./components/sections/Social";
import Location from "./components/sections/Location";
import Footer from "./components/sections/Footer";
import FloatingWhatsApp from "./components/sections/FloatingWhatsApp";

const Home = () => (
  <main className="bg-bege min-h-screen" data-testid="home-page">
    <Header />
    <Hero />
    <History />
    <Family />
    <Banner28 />
    <Gallery />
    <Social />
    <Location />
    <Footer />
    <FloatingWhatsApp />
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
